<template>
	<menu-tooltip
		v-model='menuOpen'
		class='select_button'
		:class='{"select_button--touch": !touchDisabled}'
	>
		<template slot='button'>
			<div
				class='form-select button button--thin_text border-primary pt-2 px-3'
				:class='{ "select_button__button--selected": menuOpen }'
				:style="{'border':'1px solid', 'line-height':'2'}"
				@click='menuOpen = true'
				v-if='options.length'
			>			
				{{options[selectedIndex].name}}
				<font-awesome-icon
					:icon='["fa", "chevron-down"]'
					fixed-width
					class='button__icon select_button__icon'
				/>
			</div>

			<div class='button' v-else>
				No options
			</div>
		</template>

		<template slot='menu'>
			<div
				v-for='(option, index) in options'
				:key='"select-button-option-" + option.name + index'
				@click='select(index, option.disabled)'
				class='select_button__option'
				:class='{
					"select_button__option--disabled": option.disabled,
					"select_button__option--selected": index === selectedIndex && !option.disabled
				}'
			>
				<img class="flag" :src="flag_EN" v-if="option.name == 'EN'" />
				<img class="flag" :src="flag_ES" v-else-if="option.name == 'ES'" />
				<img class="flag" :src="flag_DE" v-else-if="option.name == 'DE'" />
				<img class="flag" :src="flag_FR" v-else-if="option.name == 'FR'" />
				<img class="flag" :src="flag_CS" v-else-if="option.name == 'CS'" />
				<img class="flag" :src="flag_PL" v-else-if="option.name == 'PL'" />
				<img class="flag" :src="flag_IT" v-else-if="option.name == 'IT'" />
				<img class="flag" :src="flag_TR" v-else-if="option.name == 'TR'" />
				<img class="flag" :src="flag_EL" v-else-if="option.name == 'EL'" />
				<img class="flag" :src="flag_RO" v-else-if="option.name == 'RO'" />
				<img class="flag" :src="flag_RU" v-else-if="option.name == 'RU'" />
				<img class="flag" :src="flag_VI" v-else-if="option.name == 'VI'" />
				<img class="flag" :src="flag_JA" v-else-if="option.name == 'JA'" />
				<img class="flag" :src="flag_AR" v-else-if="option.name == 'AR'" />
				<img class="flag" :src="flag_TH" v-else-if="option.name == 'TH'" />
				<img class="flag" :src="flag_KO" v-else-if="option.name == 'KO'" />
				
				{{option.name}}
			</div>
		</template>
	</menu-tooltip>
</template>

<script>
	import MenuTooltip from './MenuTooltip';

	export default {
		name: 'SelectButton',
		props: ['options', 'value', 'name', 'touch-disabled'],
		components: {
			MenuTooltip
		},
		methods: {
			onSelect({name}) {
				console.log(name);
			},
			select (index, disabled) {
				if(disabled) return;

				this.selectedIndex = index;
				this.menuOpen = false;

				this.$emit('input', this.options[index].value);
			},
			getIndexFromValue () {
				var index = 0;
				var self = this;

				if(this.value !== null) {
					this.options.forEach((option, i) => {
						if(option.value === self.value) {
							index = i;
						}
					})
				}

				return index;
			}
		},
		data () {
			return {
				selectedIndex: this.getIndexFromValue(),
				menuOpen: false,
				flag_EN: require("../assets/img/flag/EN.png"),
				flag_ES: require("../assets/img/flag/ES.png"),
				flag_DE: require("../assets/img/flag/DE.png"),
				flag_FR: require("../assets/img/flag/FR.png"),
				flag_CS: require("../assets/img/flag/CS.png"),
				flag_PL: require("../assets/img/flag/PL.png"),
				flag_PT: require("../assets/img/flag/PT.png"),
				flag_IT: require("../assets/img/flag/IT.png"),
				flag_TR: require("../assets/img/flag/TR.png"),
				flag_EL: require("../assets/img/flag/EL.png"),
				flag_RO: require("../assets/img/flag/RO.png"),
				flag_RU: require("../assets/img/flag/RU.png"),
				flag_VI: require("../assets/img/flag/VI.png"),
				flag_JA: require("../assets/img/flag/JA.png"),
				flag_AR: require("../assets/img/flag/AR.png"),
				flag_TH: require("../assets/img/flag/TH.png"),
				flag_KO: require("../assets/img/flag/KO.png")
			}
		},
		watch: {
			value () {
				this.selectedIndex = this.getIndexFromValue();
			}
		}
	}
</script>

<style lang='scss' scoped>
	@import '../assets/scss/variables.scss';
	.select_button {
		@at-root #{&}__icon {
			font-size: 0.8rem;
			position: relative;
			top: -0.1rem;
		}

		@at-root #{&}__button--selected {
			color: $color_primary !important;
		}

		@at-root #{&}__option {
			cursor: default;
			font-size: 0.9rem;
			margin: 0.25rem 0;
			padding: 0.25rem 0.25rem;
			user-select: none;
			transition: background-color 0.2s;

			@at-root #{&}--selected {
				background-color: $color__green--primary;
			}

			&:hover {
				background-color: $color__green--darker;
			}

			@at-root #{&}--disabled {
				color: $color__gray--darkest;
				pointer-events: none;
			}
		}

	}
	.flag{
		width: 30px;
	}

	@media (max-width: $breakpoint--tablet) {
		.select_button__option {
			// font-size: 1.125rem;
			padding: 0.5rem 0.75rem;
		}

		.select_button--touch {
			.select_button {
				@at-root #{&}__option {
					padding: 0.75rem;
				}
			}
		}
	}
</style>

